import React, { PropTypes } from 'react';
import RecentlyReturnedTitle from '../RecentlyReturnedTitle';
import { FormattedMessage } from 'react-intl';
import EmptyContentPanel from '../../../shared/EmptyContentPanel';
import { BorrowingHistoryIcon } from '@bibliocommons/base-icons';
import './RecentlyReturnedIsDisabledContentPanel.scss';
import { PrimaryButton } from '@bibliocommons/base-buttons';

export default function RecentlyReturnedIsDisabledContentPanel({ handleClick }) {
  return (
    <div className="cp-recentlyreturned">
      <div className="title-row">
        <RecentlyReturnedTitle />
      </div>
      <div className="cp-recentlyreturned-disabled-content-panel">
        <EmptyContentPanel
          icon={<BorrowingHistoryIcon />}
          title={<FormattedMessage id="empty_recentlyreturned_opt_in_title" />}
          subtitle={<FormattedMessage id="empty_recentlyreturned_opt_in_text" />}>
          <div className="enable-borrowing-block">
            ‌<FormattedMessage id="form_label_retreive_borrowing_history">
              {
              (message) => (
                <PrimaryButton handleClick={handleClick} className="enable-borrowing-history btn-primary">
                  {message}
                </PrimaryButton>
              )
            }
            </FormattedMessage>
          </div>
        </EmptyContentPanel>
      </div>
    </div>
  );
}

RecentlyReturnedIsDisabledContentPanel.propTypes = {
  handleClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedIsDisabledContentPanel/RecentlyReturnedIsDisabledContentPanel.jsx